import utils from './index'
import http from '../server/index'
import store from '../store/index'
import router from '../router'

import { cryptoSingle } from './crypto'
import { CUSTOM_LOG_APP_ID } from '../enum/const'

utils.consoleLog('unityCmdHandler - router: ', router)

/**
 * 获取商品列表
 * SS三方支付代币充值接口文档：https://funplus.yuque.com/sf1r4l/orh4er/ygq2073bwszvmn4f
 */
const getProductData = async () => {
  const sdkParams = JSON.parse(window.localStorage.getItem('sdkParams') || '{}')
  const params = {
    game_id: sdkParams.gid,
    game_project: sdkParams.gproject,
    source: 'web',
    country: 'HK',
    currency: 'USD',
    openid: store.state.userInfo.openid
  }
  try {
    let responseData = []
    await http.post(`${process.env.VUE_APP_API_WEB_PAY}/api/sdk/coin_products`, params)
      .then(res => {
        utils.consoleLog('getProductData - res: ', res)
        responseData = res.map(item => ({
          ...item,
          productId: item.product_id,
          title: '',
          description: '',
          price_amount_micros: item.price,
          price: `${item.currency_symbol}${item.price}`,
          price_currency_code: item.currency
        }))
      })
      .catch(err => {
        console.log(err)
        responseData = []
      })
    return responseData
  } catch (error) {
    return []
  }
}

/**
 * 拉起支付
 * sdk参考文档：https://funplus.yuque.com/sf1r4l/gve6k9/rlhao0im0u9o1xc0
 */
const openPay = (data) => {
  utils.consoleLog('openPay - data: ', data)
  const baseUrl = data.funplusIapServer
  var utmCampaign = 'ss-webgame'
  if (utils.getPWADisplayMode === 'standalone') utmCampaign = `pwa-ss-webgame-${utils.getPlatform}`
  const paramsObj = {
    // project - 项目代号，ss_global
    p: data.projectId,
    // uid - 用户ID
    u: data.payExtJson.uid,
    // source - 支付平台，pc | website | web
    s: 'webgame',
    // country - 设备/系统国家，SG | US
    c: data.payExtJson.country || 'HK',
    // lang - 设备/系统语言，en | jp | zh-CN
    l: data.lang,
    // sku_id - 礼包id，iap_research_bundle_1
    sk: data.payExtJson.package_id,
    // name - 礼包名，资源礼包
    n: data.payExtJson.package_name,
    // product_id - 礼包档位id，com.kingsgroup.package1
    pd: data.productId,
    // currency - 礼包币种，SGD | USD
    cr: 'USD',
    // group_id - 礼包组id
    gid: data.payExtJson.group_id,
    // price - 礼包价格，6.98
    // pc: '',
    utm_campaign: utmCampaign
  }
  let [queryStr, queryArr] = ['', []]
  Object.keys(paramsObj).forEach(key => {
    queryArr.push(`${key}=${paramsObj[key]}`)
  })
  queryStr = `?${queryArr.join('&')}`
  utils.openBrowser(`${baseUrl}/sdk/pay${queryStr}`)
  utils.consoleLog('openPay - url: ', `${baseUrl}/sdk/pay${queryStr}`)
}

/**
 * 获取智能客服（FAQ）红点消息数量
 * sdk参考文档：https://funplus.yuque.com/sf1r4l/gve6k9/om0dw1r6naptzgdp
 * ?? 请求时机和参数获取？文档中获取红点消息数量的api和部分参数，是在打开FAQ的游戏传参中获取。
 */
const getFaqMsgNumber = async (data) => {
  const baseUrl = data.configJson.ticketsBaseUrl || data.configJson.baseUrl
  const appId = data.configJson.appId
  const secretKey = data.configJson.secretKey
  const userInfo = data.configJson.userInfo || {}
  const parameters = data.messageJson.parameters || {}
  store.commit('setUserInfo', userInfo)
  store.commit('setFaqConfig', data)

  const params = {
    appId,
    device_id: utils.getDeviceId(),
    gameId: Number(userInfo.gameId),
    scene: Number(parameters.scene),
    ts: new Date().getTime(),
    secretKey,
    isFaq: true
  }
  if (userInfo.fpid) {
    params.fpid = Number(userInfo.fpid || '')
  }
  if (userInfo.uid) {
    params.uid = Number(userInfo.uid || '')
  }
  try {
    const responseData = await http.post(`${baseUrl}${baseUrl.endsWith('/') ? '' : '/'}api/v2/notice`, params)
    const response = {
      code: responseData.code,
      data: responseData.data,
      message: responseData.msg,
      type: 'unread'
    }
    return JSON.stringify(response)
  } catch (error) {
    const response = {
      code: error.code,
      type: 'unread',
      message: error.message || '',
      data: null
    }
    return JSON.stringify(response)
  }
}
// getFaqMsgNumber(JSON.parse('{"configJson":{"userInfo":{"gameId":"30001","serverId":"1","fpid":"301902147041427","uid":"400000868","pkgChannel":"ss_funplus_pc","lang":"zh-CN","gameToken":"eyJhbGciOiJIUzI1NiJ9.eyJ1aWQiOjQwMDAwMDg2OCwiZnBpZCI6MzAxOTAyMTQ3MDQxNDI3LCJraWQiOjEsImNfa2lkIjoxLCJ0aW1lIjoxNjc3MDQ3NjcxLCJsb2dpbl90aW1lIjoxNjc3MDQ3NjcxLCJkZXZpY2VfaWQiOiI5NDY1QUY2NzkzNkQ0YTAxQUZEMkE4QjFDNUJBRTBERCIsInNlc3Npb25fa2V5IjoiVlJmREZWSTB0VzJCcVJ3cTZ6dUh3RDFuSkJiVDh5YVZxcGxNblU4enltWXRyYzU0In0.5e-vBM6ohbqn1SE7tEYygdp41p1QIIzV5vstwpmRstk","name":"Dev.191346"},"baseUrl":"http://ss-faq.funplus.com","baseUrlV2":"https://sscs-web-stage.funplus.com","ticketsBaseUrl":"https://fpcs-web-stage.funplus.com","isFaqV2":1,"cutoutWidth":0,"appId":"8GyET0HD3cClqNmK","secretKey":"Qw4rUcnk6vJ3ZGWbIXRC"},"messageJson":{"method":"requestUnreadMessage","parameters":{"scene":"0","device_id":"9465AF67936D4a01AFD2A8B1C5BAE0DD","fpid":"301902147041427","uid":"400000868","json_data":"{}"}}}'))

/**
 * 打开智能客服（FAQ）
 * sdk参考文档：https://funplus.yuque.com/sf1r4l/gve6k9/om0dw1r6naptzgdp
 */
const openFaq = data => {
  const userInfo = data.configJson.userInfo || {}
  const parameters = data.messageJson.parameters || {}
  const isRedirect = Number(parameters.is_redirect) === 1
  const path = isRedirect ? 'history' : 'main'
  let baseUrl = data.configJson.baseUrl
  let baseUrlv2 = data.configJson.baseUrlV2
  baseUrlv2 = baseUrlv2 + (baseUrlv2.endsWith('/') ? 'pc' : '/pc')
  if (data.configJson.isFaqV2) {
    baseUrl = data.configJson.baseUrlV2 === '' ? baseUrl : baseUrlv2
  }
  let jsonData = '{}'
  try {
    jsonData = { ...JSON.parse(parameters.json_data), fpid: userInfo.fpid, uid: userInfo.uid }
    jsonData = encodeURIComponent(JSON.stringify(jsonData))
  } catch (error) {
  }
  const paramsObj = {
    gameid: userInfo.gameId,
    sid: userInfo.serverId, // sever id
    game_token: userInfo.gameToken,
    channel: userInfo.pkgChannel, // package channel
    lang: userInfo.lang,
    name: userInfo.name || '',
    avatar: parameters.avatar || '',
    portrait: parameters.portrait || '',
    server_time: parameters.server_time || '',
    is_redirect: '',
    os: utils.getOs('no-space'),
    sdk_version: '',
    track_key: parameters.biTrackKey || '',
    device_type: utils.getDeviceType(),
    os_version: utils.getOsVersion(),
    app_version: '', // 同sdk_version
    rom_gb: '',
    remain_rom: 0,
    ram_mb: '',
    network_info: '',
    json_data: jsonData,
    ts: new Date().getTime()
  }
  let [queryStr, queryArr] = ['', []]
  Object.keys(paramsObj).forEach(key => {
    queryArr.push(`${key}=${paramsObj[key]}`)
  })
  queryStr = `?${queryArr.join('&')}`
  utils.openBrowser(`${baseUrl}${baseUrl.endsWith('/') ? '' : '/'}${path}${queryStr}`)
}

// 打开 Tickets
const openTickets = data => {
  const fpid = store.state.userInfo.fpid
  const userInfo = data.configJson.userInfo || {}
  const parameters = data.messageJson.parameters || {}
  const path = 'pc/tickets'
  const baseUrl = data.configJson.ticketsBaseUrl
  let jsonData = '{}'
  try {
    jsonData = { ...JSON.parse(parameters.json_data), fpid, uid: userInfo.uid }
    jsonData = encodeURIComponent(JSON.stringify(jsonData))
  } catch (error) {
  }
  if (!baseUrl) return
  const paramsObj = {
    gameid: userInfo.gameId,
    channel: userInfo.pkgChannel, // package channel
    subchannel: userInfo.pkgChannel, // package channel
    pkgChannel: userInfo.pkgChannel, // package channel
    lang: userInfo.lang,
    os: utils.getOs('no-space'),
    sdk_version: '1.0.0',
    app_version: '1.0.0',
    os_version: utils.getOsVersion(),
    device_type: utils.getDeviceType(),
    rom_gb: '',
    remain_rom: 0,
    ram_mb: '',
    network_info: '',
    country_code: userInfo.lang.replace('-', '_'),
    device_id: utils.getDeviceId(),
    track_key: parameters.biTrackKey || '',
    role_id: userInfo.uid,
    role_name: userInfo.name,
    sid: userInfo.serverId, // sever id
    game_token: userInfo.gameToken,
    scene: parameters.scene,
    pay_amount: 0,
    json_data: jsonData,
    ts: new Date().getTime()
  }
  let [queryStr, queryArr] = ['', []]
  Object.keys(paramsObj).forEach(key => {
    queryArr.push(`${key}=${paramsObj[key]}`)
  })
  queryStr = `?${queryArr.join('&')}`
  utils.openBrowser(`${baseUrl}${baseUrl.endsWith('/') ? '' : '/'}${path}${queryStr}`)
}
// openTickets(JSON.parse('{"configJson":{"userInfo":{"gameId":"30001","serverId":"","fpid":"","uid":"","pkgChannel":"ss_funplus_pc","lang":"zh-CN","gameToken":"","name":""},"baseUrl":"","baseUrlV2":"https://sscs-web.funplus.com","ticketsBaseUrl":"https://fpcs-web.funplus.com","isFaqV2":1,"cutoutWidth":0,"appId":"8GyET0HD3cClqNmK","secretKey":"Qw4rUcnk6vJ3ZGWbIXRC"},"messageJson":{"method":"openTickets","parameters":{"biTrackKey":"19b45bc7a72ecbcddb60dade18741a4e","scene":"1","fpid":"","uid":"","gameToken":"","name":"","device_id":"9465AF67936D4a01AFD2A8B1C5BAE0DD","json_data":"{}"}}}'))

/**
 * init community
 * @param {Object} data 游戏数据
 */
const initCommunity = async data => {
  const { userInfo, baseUrlV2 } = data || { userInfo: {} }
  window.localStorage.setItem('community_data', JSON.stringify(data))
  store.commit('setUserInfo', userInfo)
  const params = {
    avatar: userInfo.avatar,
    channel: userInfo.pkgChannel,
    city_lv: userInfo.cityLv,
    fpid: userInfo.fpid,
    game_token: userInfo.gameToken,
    gameid: userInfo.gameId,
    lang: userInfo.lang,
    lord_lv: userInfo.lordLv,
    name: userInfo.name || '',
    os: utils.getOs(),
    portrait: userInfo.portrait || '',
    sid: userInfo.serverId, // sever id
    sdk_version: '2.3',
    server_time: userInfo.serverTime,
    uid: userInfo.gameUid,
    vertical_plate: '',
    vip_lv: userInfo.vipLv
  }
  try {
    const responseData = await http.get(`${baseUrlV2 ? baseUrlV2 + '/api/init' : '/communityApi/init'}`, params)
    const response = {
      code: 0,
      data: {
        imgUrl: responseData.img,
        name: responseData.name,
        notice: responseData.notice,
        show: responseData.show
      },
      message: 'ok',
      type: 'init'
    }
    return response
  } catch (error) {
    console.log(error)
    return {}
  }
}

/**
 * 打开社区
 * sdk参考文档：
 */
const openCommunity = data => {
  try {
    data = typeof data === 'string' ? JSON.parse(data) : data
  } catch (error) {}
  const { baseUrlV2, userInfo } = JSON.parse(window.localStorage.getItem('community_data') || '{"userInfo":{}}')
  const { articleType, articleId, extend, ...parameters } = data.parameters
  const paramsObj = {
    gameid: userInfo.gameId,
    sid: userInfo.serverId, // sever id
    fpid: userInfo.fpid,
    uid: userInfo.gameUid,
    os: utils.getOs(),
    channel: userInfo.pkgChannel, // package channel
    lang: userInfo.lang,
    game_token: userInfo.gameToken,
    sdk_version: '2.3',
    track_key: parameters.biTrackKey || '',
    name: parameters.name || '',
    avatar: parameters.avatar || '',
    portrait: parameters.portrait || '',
    server_time: parameters.serverTime || '',
    city_lv: userInfo.cityLV,
    lord_lv: userInfo.lordLV,
    vip_lv: userInfo.vipLV
  }
  if (articleType) {
    paramsObj.article_type = articleType
  }
  if (articleId) {
    paramsObj.article_id = articleId
  }
  if (extend) {
    paramsObj.extend = extend
  }

  let [queryStr, queryArr] = ['', []]
  Object.keys(paramsObj).forEach(key => {
    queryArr.push(`${key}=${paramsObj[key]}`)
  })
  queryStr = `?${queryArr.join('&')}`
  utils.openBrowser(`${baseUrlV2}${baseUrlV2.endsWith('/') ? '' : '/'}ss${queryStr}`)
}

/**
 * Game Crash上报
 * 消息格式：{"cmd":"game_crashed","data":{"gameVersion": "","package":"","content":""}}
 * @param {Object} data {"gameVersion": "","package":"","content":""}
 */
const sendGameCrashedLog = data => {
  utils.consoleLog('sendGameCrashedLog', data)
  const secret = 'e03b0da71d31f4c9e55b6f547f782097'
  const customLogApi = process.env.VUE_APP_LOG_CUSTOM_API
  const sdkParams = JSON.parse(window.localStorage.getItem('sdkParams') || '{}')

  const deviceId = utils.getDeviceId()
  const sign = cryptoSingle(secret, deviceId)
  const appId = CUSTOM_LOG_APP_ID[sdkParams.gid]

  /* eslint-disable */
  const headers = {
    'Content-Type': 'application/json',
    'X-Content-Secret': sign,
    'event': 'web_game_crashed',
    appId,
    // 'env': '',
    // 'platform': '',
    // 'type': '',
    appVersion: data.gameVersion,
    osVersion: utils.getOsVersion(),
    clickCode: utils.clickInfo().clickcode,
    deviceId,
    // fileName: data.package.replaceAll('\n', ' '),
    content: JSON.stringify({
      osName: (window.crtDevice.os || {}).name,
      osVersion: (window.crtDevice.os || {}).version,
      browserName: (window.crtDevice.browser || {}).name,
      browserVersion: (window.crtDevice.browser || {}).version,
      deviceModel: (window.crtDevice.device || {}).model || '',
      deviceType: (window.crtDevice.device || {}).type || '',
      content: data.package.replaceAll('\n', ' ')
    })
  }
  utils.consoleLog('sendGameCrashedLog - headers: ', headers)
  fetch(customLogApi, {
    method: 'post',
    body: '',
    credentials: 'include',
    mode: 'cors',
    // headers: new Headers(headers)
    headers: { ...headers }
  }).then(response => {
    utils.consoleLog('sendGameCrashedLog completed')
  }).catch(err => {
    utils.consoleLog('sendGameCrashedLog faild', err)
  })
  /* eslint-enable */
}

/**
 * 刷新device_uuid
 * 消息格式："{"cmd":"refresh_device_uuid","device_uuid":"edb76c81-9130-489a-8b25-ffa6b81f5915"}"
 */
const refreshDeviceUuid = deviceUUID => {
  if (!deviceUUID) return
  utils.consoleLog('refreshDeviceUuid', deviceUUID)
  utils.setDeviceUUId(deviceUUID)
}

export default {
  getProductData,
  openPay,
  getFaqMsgNumber,
  openFaq,
  openTickets,
  initCommunity,
  openCommunity,
  sendGameCrashedLog,
  refreshDeviceUuid
}
